import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { updateToastInfo } from '../../actions/settings';
import { updateSpinnerState } from '../../actions/spinner';
import { setVendorsListInStore } from '../../actions/vendors';
import {
  addNewVehicleVendor,
  getVendorsListInRegion,
} from '../../parse-functions/vendors';
import { convertArrayToObj } from '../../utils/json';
import { returnVendorListTableColumns } from './vendorsUtils';
import { Button, ButtonGroup, Modal } from '@themesberg/react-bootstrap';
import AddVendor from './add';
import BreadCrumbTitle from '../scheme-management/Components/common/BreadCrumbTitle';
import ExcelDownloadReport from '../../components/common/excel/download';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRefresh } from '@fortawesome/free-solid-svg-icons';
import TripsTableData from '../trips/tripsTableData';

const VendorsList = () => {
  const { t } = useTranslation();
  const pageStatus = 'vendorsList';
  const dispatch = useDispatch();
  const zone = useSelector((state) => state?.user?.warehouse?.zone || '');
  const vendorsList = useSelector(
    (state) => state?.vendors?.[pageStatus] || {}
  );
  const [editData, setEditData] = useState('');
  const [showEditModal, setShowEditModal] = useState(false);

  useEffect(() => {
    if (Object.keys(vendorsList) < 1 && zone) {
      getAvailableVendorList();
    }
  }, [zone]);
  const getAvailableVendorList = async () => {
    dispatch(updateSpinnerState(true));
    try {
      const filters = {
        zone,
        // status: 'active',
      };
      const vendors = await getVendorsListInRegion(filters);
      dispatch(
        setVendorsListInStore(
          convertArrayToObj(JSON.parse(JSON.stringify(vendors)), 'objectId')
        )
      );
      dispatch(updateSpinnerState(false));
      dispatch(
        updateToastInfo({
          show: true,
          type: 'success',
          title: t('Vehicle Vendors fetched'),
          message: t('All the Vehicle Vendors for the zone are listed here'),
        })
      );
    } catch (e) {
      dispatch(updateSpinnerState(false));
      dispatch(
        updateToastInfo({
          show: true,
          type: 'danger',
          title: t('Error'),
          message: t(e.message),
        })
      );
    }
  };

  const onRefreshClick = () => {
    getAvailableVendorList();
  };

  const handleSelectedRowUpdate = (actionId, row) => {
    switch (actionId) {
      case 'Edit': {
        let data = Object.values(vendorsList || {}).find(
          (user) => user.objectId === row.objectId
        );
        setEditData(data);
        setShowEditModal(true);
        break;
      }
      case 'Activate': {
        handleSave({
          statusUpdate: true,
          objectId: row.objectId,
          status: 'active',
          isEdit: true,
        });
        break;
      }
      case 'Deactivate': {
        handleSave({
          statusUpdate: true,
          objectId: row.objectId,
          status: 'deleted',
          isEdit: true,
        });
        break;
      }
    }
  };

  const handleSave = async (data) => {
    try {
      dispatch(updateSpinnerState(true));
      await addNewVehicleVendor({ ...data, isEdit: true });
      const vendors = await getVendorsListInRegion({
        zone,
        // status: 'active',
      });
      dispatch(
        setVendorsListInStore(
          convertArrayToObj(JSON.parse(JSON.stringify(vendors)), 'objectId')
        )
      );
      dispatch(
        updateToastInfo({
          show: true,
          type: 'success',
          title: t('Vehicle Vendors fetched'),
          message: t('All the Vehicle Vendors for the zone are listed here'),
        })
      );
      setShowEditModal(false);
    } catch (error) {
      dispatch(
        updateToastInfo({
          show: true,
          type: 'danger',
          title: t('Error'),
          message: t(error.message),
        })
      );
    } finally {
      dispatch(updateSpinnerState(false));
    }
  };
  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <BreadCrumbTitle breadcrumbs={[{ title: 'Vendors List' }]} />
        </div>
        <ButtonGroup>
          <Button onClick={onRefreshClick} variant="outline-primary" size="sm">
            <FontAwesomeIcon icon={faRefresh} />
            &nbsp;&nbsp;{t('Refresh')}
          </Button>
          <ExcelDownloadReport
            data={Object.values(vendorsList) || []}
            fileName={`${pageStatus}`}
          />
        </ButtonGroup>
      </div>
      <TripsTableData
        data={vendorsList}
        columns={returnVendorListTableColumns(handleSelectedRowUpdate)}
        page={pageStatus}
      />
      {/* <ParcelStatusPage
        pageType={pageStatus}
        showDateFilters={false}
        tableData={vendorsList}
        tableColumns={returnVendorListTableColumns(handleSelectedRowUpdate)}
        handleRefresh={onRefreshClick}
        pageTitle={t('Vehicle Vendors')}
        breadCrumbItems={breadCrumbItems}
        pageSubTitle={t(
          'All the vendors who are associated with us and provide us with vehicles'
        )}
        searchPlaceHolder={t('Search By Vendor Code')}
        hideBulkActions={true}
        enableBulkActions={false}
      /> */}
      <Modal
        centered
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        className="modal-primary"
        size="xl"
      >
        <Modal.Header className="d-flex justify-content-between align-items-center p-3">
          <p className="lead mb-0">{t('Edit Vendor')}</p>
          <Button
            variant="transparent"
            className="btn-close"
            onClick={() => setShowEditModal(false)}
          />
        </Modal.Header>
        <Modal.Body>
          <AddVendor editData={editData} handleSave={handleSave} />
        </Modal.Body>
      </Modal>
    </>
  );
};
export default VendorsList;
